import { Alert, Box, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import ProductList from "components/ProductList/ProductList";
import NewApplicationSidebar from "sections/Sidebar/NewApplicationSidebar";
import SelectCarrier from "components/SelectCarrier/SelectCarrier";
import StartApplication from "components/StartApplication/StartApplication";
import AnimatedLoader from "components/Loader/AnimatedLoader";
import CustomModal from "components/CustomModal/CustomModal";
import { useAuth } from "hooks/useAuth";

import { setSnackbar } from "../../../redux/modules";
import {
  useAddApplicationMutation,
  useGetApplicationDataQuery,
  useGetFeaturedIconsQuery
} from "../../../redux/modules/catalog";
import CheckEligibility from "./InitiateApplication/CheckEligibility";

export const NewApplication = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [productSelected, setProductSelected] = useState(null);
  const [questionList, setQuestionList] = useState(null);
  const [showNoCarrier, setShowNoCarrier] = useState(false);
  const [industryId, setIndustryId] = useState(null);
  const [apiPayload, setApiPayload] = useState([]);
  const [applicationId, setApplicationId] = useState(null);
  const [applicationProgress, setApplicationProgress] = useState("0");
  const [screen, setScreen] = useState("ProductList");
  const [startApplicationData, setStartApplicationData] = useState(null);
  const [carriers, setCarriers] = useState([]);
  const [applicationData, setApplicationData] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [snackbarData, setSnackbarData] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();

  const screenFromUrl = searchParams.get("currentScreen");
  const appId = searchParams.get("applicationId");


  const [addApplication, {}] = useAddApplicationMutation();

  const { user } = useAuth();

  const { data: applicationAPIData, refetch } = useGetApplicationDataQuery(
    { token: user?.token, applicationId },
    { skip: applicationId === null, refetchOnMountOrArgChange: true }
  );

  const isApplicationCreated =
  applicationAPIData?.application?.applicationData?.isDisabled;

  useEffect(() => {
    if (applicationId) {
      refetch();
    }
  }, [applicationId]);

  useEffect(() => {
    if (screenFromUrl && appId) {
      if (
        screenFromUrl === "CheckEligibility" ||
        screenFromUrl === "StartApplication"
      ) {
        setApplicationProgress("29");
      } else if (screenFromUrl === "SelectCarrier" && !isApplicationCreated) {
        setApplicationProgress("2");
      }
      setScreen(screenFromUrl);
      setApplicationId(appId);
      setQuestionList(
        applicationAPIData?.application?.applicationData?.questions
      );
      setIndustryId(
        applicationAPIData?.application?.applicationData?.industryId
      );

      setProductSelected(
        applicationAPIData?.application?.applicationData?.productSelected
      );
    }
  }, [screenFromUrl, applicationAPIData]);


  const dispatch = useDispatch();

  useEffect(() => {
    if (productSelected !== null) {
      if (productSelected?.naicsDescription) {
        setInputValue(
          `${productSelected?.code}: ${productSelected?.naicsDescription}`
        );
      } else {
        setInputValue(productSelected?.code);
      }
    }
  }, [productSelected]);

  const handleOpen = () => {
    setOpen(true);
  };

  // const { snackbar } = useSelector(selectSnackbarState);

  const { data } = useGetFeaturedIconsQuery({}, { skip: false });

  const handleCloseSnackbar = () => {
    setSnackbarData({
      message: "",
      severity: "success"
    });
    setOpenSnackbar(false);
    dispatch(
      setSnackbar({
        openSnackbar: false,
        snackbarData: {
          message: "",
          severity: ""
        }
      })
    );
  };

  const handleBack = () => {
    switch (screen) {
      case "SelectCarrier":
        setScreen("ProductList");
        if (selectedCard === null) {
          setInputValue("");
          setSelectedCard(null);
          setProductSelected(null);
          return;
        }
        break;
      case "StartApplication":
        setScreen("CheckEligibility");
        break;
      case "CheckEligibility":
        setScreen("SelectCarrier");
        break;
    }
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };  

  const renderUI = () => {
    switch (screen) {
      case "SelectCarrier":
        return (
          <SelectCarrier
            selectedCard={selectedCard}
            setProductSelected={setProductSelected}
            inputValue={inputValue}
            productSelected={productSelected}
            setInputValue={setInputValue}
            setSelectedCard={setSelectedCard}
            showNoCarrier={showNoCarrier}
            setShowNoCarrier={setShowNoCarrier}
            industryId={industryId}
            setIndustryId={setIndustryId}
            apiPayload={apiPayload}
            setApiPayload={setApiPayload}
            setOpenSnackbar={setOpenSnackbar}
            setSnackbarData={setSnackbarData}
            setApplicationId={setApplicationId}
            setScreen={setScreen}
            setApplicationData={setApplicationData}
            setLoading={setLoading}
            handleBack={handleBack}
            applicationAPIData={applicationAPIData}
            applicationId={applicationId}
            applicationData={applicationData}
            refetch={refetch}
            addApplication={addApplication}
          />
        );
      case "CheckEligibility":
        return (
          <CheckEligibility
            setApplicationProgress={setApplicationProgress}
            questionList={questionList}
            productSelected={productSelected}
            applicationData={applicationData}
            setOpenSnackbar={setOpenSnackbar}
            setSnackbarData={setSnackbarData}
            setApplicationData={setApplicationData}
            industryId={industryId}
            apiPayload={apiPayload}
            setApiPayload={setApiPayload}
            showNoCarrier={showNoCarrier}
            setShowNoCarrier={setShowNoCarrier}
            setRiskType={setRiskType}
            applicationId={applicationId}
            setApplicationId={setApplicationId}
            setScreen={setScreen}
            setCarriers={setCarriers}
            setStartApplicationData={setStartApplicationData}
            setLoading={setLoading}
            handleBack={handleBack}
            applicationAPIData={applicationAPIData}
            refetch={refetch}
          />
        );
      case "StartApplication":
        return (
          <StartApplication
            startApplicationData={startApplicationData}
            carriers={carriers}
            applicationId={applicationId}
            industryId={industryId}
            riskType={riskType}
            applicationData={applicationData}
            setApplicationData={setApplicationData}
            setLoading={setLoading}
            handleBack={handleBack}
            handleOpen={() => handleOpen()}
            applicationAPIData={applicationAPIData}
            setSnackbarData={setSnackbarData}
            setOpenSnackbar={setOpenSnackbar}
          />
        );
      case "ProductList":
        return (
          <ProductList
            data={data?.featuredIcons}
            inputValue={inputValue}
            setInputValue={setInputValue}
            showSearchBox={showSearchBox}
            selectedCard={selectedCard}
            setShowSearchBox={setShowSearchBox}
            setSelectedCard={setSelectedCard}
            setApplicationProgress={setApplicationProgress}
            setSnackbarData={setSnackbarData}
            setOpenSnackbar={setOpenSnackbar}
            setProductSelected={setProductSelected}
            setScreen={setScreen}
            setApplicationData={setApplicationData}
            setLoading={setLoading}
          />
        );
      default:
        return (
          <div className="h-[calc(100vh-140px)] flex justify-center items-center">
            <AnimatedLoader />
          </div>
        );
    }
  };

  const getHeading = () => {
    switch (screen) {
      case "SelectCarrier":
        return "Select Carriers";
      case "StartApplication":
        return "Select Account Name";
      case "CheckEligibility":
        return "";
      default:
        return "Select Industry";
    }
  };

  return (
    <>
      <NewApplicationSidebar applicationProgress={applicationProgress}>
        <Box className="w-full h-[calc(100vh-60px)] p-6 bg-[#F9FAFB] relative">
          {isLoading && (
            <div className="absolute z-50 w-full h-full top-0 bg-[#f9fafb4a] flex justify-center items-center right-0 ">
              <div className="bg-white rounded-full">
                <AnimatedLoader />
              </div>
            </div>
          )}
          <div className="text-[#0B1524] text-[18px] font-[500] ">
            {getHeading()}
          </div>
          {renderUI()}
        </Box>
      </NewApplicationSidebar>
      <CustomModal
        setSnackbarData={setSnackbarData}
        setOpenSnackbar={setOpenSnackbar}
        open={open}
        cameFrom="startApplication"
        setProgress={() => setScreen("StartApplication")}
        handleClose={handleClose}
      />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarData.severity}
          sx={{ width: "100%" }}
        >
          {snackbarData.message}
        </Alert>
      </Snackbar>
    </>
  );
};
